import { Timestamp } from 'firebase/firestore'

export const transformDates = object => {
  const transformedObject = {}

  for (const [key, value] of Object.entries(object)) {
    let finalValue = value

    if (value instanceof Timestamp) finalValue = value.toDate()
    else if (value instanceof Object) finalValue = transformDates(value)

    transformedObject[key] = finalValue
  }

  return sortFields(transformedObject)
}

export const sortFields = object => {
  return Object.keys(object)
    .sort((a, b) => a.localeCompare(b))
    .reduce((obj, key) => {
      obj[key] = object[key]
      return obj
    }, {})
}
